<template>
<div class="create-contact">

  <vue-headful
    title="TZ Design Box - Create Contact"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'create-contact'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("create-contact") }}</h2>
          <p>{{ $t("contact-create-details") }}</p>
          <form @submit.prevent="validateBeforeSubmit">
            <b-field :label="$t('email')"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')">
            <b-input v-model="contact.email" name="email" v-validate="'required|email'" />
            </b-field>

            <b-field :label="$t('firstname')"
            :type="{'is-danger': errors.has('first_name')}"
            :message="errors.first('first_name')">
            <b-input v-model="contact.first_name" name="first_name" v-validate="'required'" />
            </b-field>
            <b-field :label="$t('secondname')"
            :type="{'is-danger': errors.has('middle_name')}"
            :message="errors.first('middle_name')">
            <b-input v-model="contact.middle_name" name="middle_name" />
            </b-field>
            <b-field :label="$t('lastname')"
            :type="{'is-danger': errors.has('last_name')}"
            :message="errors.first('last_name')">
            <b-input v-model="contact.last_name" name="last_name" />
            </b-field>

            <b-field :label="$t('language')">
            <b-select :value="getCurrentCompany.language" v-model="getCurrentCompany.language">
                            <option
                    v-for="language in getCurrentCompany.language_choices"
                    :value="language[0]"
                    :key="language[0]">
                    {{ language[1] }}
                </option>
            </b-select>
            </b-field>

              <b-field label="" class="is-checkradio"
                  :type="{'is-danger': errors.has('dealer_admin')}"
                  :message="{'required' : errors.firstByRule('dealer_admin', 'required')}">
                  <b-checkbox v-model="contact.dealer_admin" name="dealer_admin">
                      {{ $t("dealer-admin") }}
                  </b-checkbox>
              </b-field>

              <b-field label="" class="is-checkradio"
                  :type="{'is-danger': errors.has('opt_out')}"
                  :message="{'required' : errors.firstByRule('opt_out', 'required')}">
                  <b-checkbox v-model="contact.opt_out" name="opt_out">
                      {{ $t("newsletter") }}
                  </b-checkbox>
              </b-field><br>

            <button type="submit" class="button is-primary"> {{ $t("save") }} </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'

export default {
    name:'CreateContact',
    computed: {...mapGetters (["getCurrentCompany","getCompany"])
    },
    data: function(){
        return{
            contact:{}
        }
    },
    components: { MenuVert, Breadcrumbs},
    methods: {
        validateBeforeSubmit () {
            var self=this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.contact.language = this.getCurrentCompany.language
                    this.$store.dispatch (
                        "createContact",
                        {contact: this.contact, cid: this.getCompany, self: self}
                    )
                    .catch((error) => {
                        self.$toastr ('error', error, 'Failure')
                    })
                    return
                }
            })
        }
    },
    created () {
        let self = this
        this.$store.dispatch (
            "callCurrentCompany", {self: self,company: this.getCompany})
    }
}
</script>

<style>
.create-contact{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
